import { render, staticRenderFns } from "./widget-header.vue?vue&type=template&id=084539f5&scoped=true&"
import script from "./widget-header.vue?vue&type=script&lang=js&"
export * from "./widget-header.vue?vue&type=script&lang=js&"
import style0 from "./widget-header.vue?vue&type=style&index=0&id=084539f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084539f5",
  null
  
)

export default component.exports